








import { Layout } from "@/types/layout";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LayoutFullWidth extends Vue {
  beforeCreate() {
    this.$store.dispatch("setLayout", Layout.IS_FULL_WIDTH);
  }

  @Prop({ required: false, default: "" })
  layoutWidth!: "small" | "form";

  get widthClass() {
    return this.layoutWidth ? `layout-full-width-${this.layoutWidth}` : ``;
  }
}
